export default __webpack_public_path__ + "static/media/cprofile4.75d9a5b3.png";